
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Trykk på «Åpne i nettleser…»`,
's182ab2d6c997515f': `Legg den til på Hjem-skjermen din for å få en bedre brukeropplevelse og raskere tilgang.`,
's224cbcec014ef6b5': `Trykk på Del-knappen i navigasjonslinjen`,
's233af3b7eb5e0364': `Legg til på startsiden`,
's37a9e8aec5713460': `Mer`,
's4c3161035f3a1413': `Trykk på Meny`,
's4e1e10a6ca408245': `Trykk på "Legg til på Hjem-skjerm"`,
's6196153c4b0c1ea0': `Installer`,
's633502f7cff4f847': `Åpne menyen i nettleseren din`,
's681e399d63311fba': `Vis galleri`,
's6d14a4f70ba4e3cf': `Trykk på Meny hvis det ikke er noe delingsikon`,
's922329d6f6213590': `Legg til i Dock`,
's9c63a79ffcc2a3a3': `Trykk på «Legg til på Hjem-skjerm»`,
'sa2d71bfd9525168d': `Trykk på «Legg til i Dock»`,
'sa5ef80b4bb9b39f8': `Mindre`,
'sb527eca1c1d7e7be': `Åpne nettlesermenyen i appen`,
'sba52286c21552a4e': `Installer den på enheten din for å få en bedre brukeropplevelse og raskere tilgang.`,
'sc16e00a7a8b2fde2': `Tilbake`,
'scdaf4bbff76674c8': `Legg til på Hjem-skjerm`,
'sd18a5b85f599ff3c': `Åpne den kopierte lenken i Safari`,
'se72fc3a84f9b51c3': `Trykk for å kopiere lenken`,
'se740f75b95a51807': `Legg den til i Docken din for å få en bedre brukeropplevelse og raskere tilgang.`,
'sfa6c42cdf48d93d2': `Men denne nettleseren støtter ikke denne funksjonen. Åpne lenken i en ekstern nettleser for å fortsette.`,
'sfb78526365796a41': `Trykk på «Vis mer» i delingsmenyen`,
'sfea652f6580ff086': `Denne siden har app-funksjonalitet.`,
    };
  